import * as React from "react";

import "./date-picker-field.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load}           from "@Common/react/load";
import {UseState}       from "@Common/react/use-state";
import {DatePicker}     from "@Common/ui-components/date-picker/date-picker";
import {parseDate}      from "@Common/utils/date-object";
import {paddingLeft}    from "@Common/utils/strings";

export const DatePickerField = ({textField}) => (
    <div className="relative">
        <div className="group">
            <div className="line">
                <div className="input">
                    {cs(
                        consumeContext("apis"),
                        ["date", (_, next) => UseState({initValue: textField.value, next})],
                        ["rule",  ({apis}, next) => Load({
                            fetch: async () => await apis.listings.getRule(textField.rule),
                            next,
                        })],
                        ({date, rule}) => (
                            <DatePicker {...{

                                value: date.value && parseDate(`${date.value} UTC`),
                                onChange: (d) => handleChange(date,d,textField),

                                "xd-qa-type":"date_select",
                                style:{
                                    borderColor: textField.isRequired && !textField.value ? "red": null,
                                    borderWidth: textField.isRequired && !textField.value ? 2: null,
                                }
                            }}/>
                        ),
                    )}
                </div>
            </div>
        </div>
    </div>
);


function handleChange(date, d, textField) {
    if(d){
        date.value =`${paddingLeft(d.month)}/${paddingLeft(d.day)}/${d.year}`;
        textField.value= `${paddingLeft(d.month)}/${paddingLeft(d.day)}/${d.year}`;
        date.onChange(`${paddingLeft(d.month)}/${paddingLeft(d.day)}/${d.year}`);
        textField.onChange(`${paddingLeft(d.month)}/${paddingLeft(d.day)}/${d.year}`);
    }
    else{
        date.value = '';
        textField.value= '';
        date.onChange('');
        textField.onChange('');
    }
}

